import { render, staticRenderFns } from "./tabs-pane.vue?vue&type=template&id=66c2df06&scoped=true&"
import script from "./tabs-pane.vue?vue&type=script&lang=js&"
export * from "./tabs-pane.vue?vue&type=script&lang=js&"
import style0 from "./tabs-pane.vue?vue&type=style&index=0&id=66c2df06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2df06",
  null
  
)

component.options.__file = "tabs-pane.vue"
export default component.exports